import ShipmentScreen from "./index";

const routes = [
  {
    path: "/shipment/:id",
    component: ShipmentScreen,
  },
];

export default routes;
